<div class="page-header">
  <div class="grid-container">
  <div class="domain-header">User Settings</div>
  <div class="navigation-section">
    <button class="iana-navigation-button" [disabled]="profileView" (click)="changeViewToProfile()">User Profile</button>
    <button class="iana-navigation-button" *ngIf="!staffView" [disabled]="changePasswordView" (click)="changeViewToChangePasswordView()">Password and Authentication</button>
    <button class="iana-navigation-button" [disabled]="auditLogView" (click)="changeViewToActivityLog()">Audit Log</button>
  </div>
  </div>
</div>
<div class="grid-container">
<div *ngIf="profileView">
  <user-profile></user-profile>
</div>
<div *ngIf="auditLogView">
  <lib-user-audit-log></lib-user-audit-log>
</div>
<div *ngIf="changePasswordView && !staffView">
  <change-password></change-password>
  <lib-id-verification-settings></lib-id-verification-settings>
  <lib-two-factor-authentication></lib-two-factor-authentication>
  <api-tokens></api-tokens>
</div>
</div>
